import { jwtDecode } from 'jwt-decode';

import { keyConst } from '@/constants';
import { CLIENT_PREVIEW_MODE } from '@/constants/client-preview.constant';

import { DecodedToken } from '@/interface';

export const getClientPreviewState = () => {
  const token = localStorage.getItem(keyConst.userToken);
  if (!token) return { isClientPreview: false, previewedByUserId: null };

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const previewedByUserId = decoded.previewedByUserId || decoded.impersonatedByUserId || null;

    return {
      isClientPreview: decoded.mode === CLIENT_PREVIEW_MODE.CLIENT_PREVIEW || Boolean(previewedByUserId),
      previewedByUserId,
    };
  } catch {
    return { isClientPreview: false, previewedByUserId: null };
  }
};

export const useClientPreview = () => getClientPreviewState();
